<div class="row mt-auto mb-auto">
  <div class="col-12">

      <div class="mb-4 d-flex flex-row align-items-center">
        <ng-template #backTo> Back to integrations </ng-template>
        <a class="btn btn-icon" [ngbTooltip]="backTo" href="/updates/integrations"><fa-icon [icon]="['fas', 'chevron-left']" size="2x" class="text-center" [fixedWidth]="true"></fa-icon></a>
        <h2 class="mb-0">Azure Active Directory / Single Sign-On</h2>
      </div>

      <div class="row mb-4">
        <div class="col-12">

          <p>Azure AD integration enable to authenticate your users with Single Sign-On</p>
          <p>Register your Azure AD configuration to allow SS0</p>
          <p>Here are your environnement settings to sign in with Azure Active Directory</p>

          <div class="card" *ngIf="view === 'notConfigured'">
            <div class="card-body">
                <div class="card-title">
                    <h4>
                      Single Sign-On with Azure AD
                    </h4>
                </div>
                <p>Single Sign-On with Azure Active Directory isn't configured</p>
                <button class="btn btn-primary" (click)="setupSAML();">{{ 'pages.updates.integrations.setupSaml' | translate }}</button>


            </div>
          </div>

          <div class="card" *ngIf="view === 'editConfiguration'">
              <div class="card-body">
                  <div class="card-title">
                      <h4>
                        Single Sign-On with Azure AD
                      </h4>
                  </div>

                  <div >
                    <h4>Setup SAML Configuration</h4>
                    <form>
                        <div class="form-row">
                            <div class="col-xl-6 col-lg-6 col-md-9 col-sm-9 col-xs-12 mb-3" >
                                <label for="domain">{{ 'pages.updates.integrations.fieldTitles.domain' | translate }} 
                                  <app-help message="{{'pages.updates.integrations.domainDesc' | translate}}"></app-help>
                                </label>
                                <input type="text" class="form-control" name="domain" aria-describedby="domain" placeholder="" [(ngModel)]="domain" placeholder="company.com">
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-xl-6 col-lg-6 col-md-9 col-sm-9 col-xs-12 mb-3">
                                <label for="singleSignOnURL">{{ 'pages.updates.integrations.fieldTitles.singleSignOnURL' | translate }}
                                  <app-help message="{{'pages.updates.integrations.singleSignOnURLDesc' | translate}}"></app-help>
                                </label>
                                <input type="url" class="form-control" name="singleSignOnURL" aria-describedby="singleSignOnURL" [(ngModel)]="singleSignOnURL" placeholder="https://company.azuread.com/app/examplessourl/sso/saml">
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-xl-6 col-lg-6 col-md-9 col-sm-9 col-xs-12 mb-3">
                                <label for="x509certificate">{{ 'pages.updates.integrations.fieldTitles.x509certificate' | translate }}
                                  <app-help message="{{'pages.updates.integrations.x509certificateDesc' | translate}}"></app-help>
                                </label>
                                <textarea class="form-control" rows="10" name="x509certificate" aria-describedby="x509certificate" [(ngModel)]="x509certificate" placeholder="-----BEGIN CERTIFICATE-----&#10;&#10;&#10;&#10;-----END CERTIFICATE-----"></textarea>
                            </div>
                        </div>
                        
                        <button class="btn btn-primary" (click)="save();">{{ 'pages.generic.save' | translate }}</button>
                      
                        <ngb-alert *ngIf="showConfigurationSaved" style="margin-top:10px" type="success" (click)="closeAlert()">{{ 'pages.generic.configurationSaved'  | translate }} </ngb-alert>

                    </form>
                  </div>

              </div>
          </div>

          <div class="card" *ngIf="view === 'configured'">
            <div class="card-body">
                <div class="card-title">
                  <h4>
                    Single Sign-On with Azure AD
                  </h4>
                </div>

                <h4>
                  Authentification configuration
                </h4>

                <div class="mt-1 mb-1">
                  <h6 class="mb-0">SAML</h6>
                  <p>Enabled for Portal</p>
                </div>

                <div class="mt-1 mb-1">
                  <h6 class="mb-0">Email Domain</h6>
                  <p>company.com</p>
                </div>

                <div class="mt-1 mb-1">
                  <h6 class="mb-0">Single Sign-On URL</h6>
                  <p>https://company.azuread.com/app/examplessourl/sso/saml</p>
                </div>

                <div class="mt-1 mb-1">
                  <h6 class="mb-0">X509 certificate fingerprint</h6>
                  <p><code>47:5D:A9:48:E4:BA:44:D9:B5:BC:31:AB:4B:80:06:11:3F:D5:F5:38</code></p>
                </div>        

            </div>
          </div>

          <div class="card" *ngIf="view === 'notAvailable'">
            <div class="card-body">
                <div class="card-title">
                  <h4>
                    Single Sign-On with Azure AD
                  </h4>
                </div>

                <h4>
                  Authentification configuration
                </h4>

                <div class="mt-1 mb-3">
                  <h6 class="mb-0">SAML</h6>
                  <input type="text" class="fakeinput" placeholder="" disabled>
                </div>

                <div class="mt-1 mb-3">
                  <h6 class="mb-0">Email Domain</h6>
                  <input type="text" class="fakeinput" placeholder="" disabled>
                </div>

                <div class="mt-1 mb-3">
                  <h6 class="mb-0">Single Sign-On URL</h6>
                  <input type="url" class="fakeinput" placeholder="" disabled>
                </div>

                <div class="mt-1 mb-3">
                  <h6 class="mb-0">X509 certificate fingerprint</h6>
                  <input type="text" class="fakeinput large" placeholder="" disabled>
                </div>      
                
                <ngb-alert *ngIf="alertNotAvailable" type="danger" (click)="closeAlert()">
                  {{ 'pages.updates.integrations.notAvailable' | translate }} 
                </ngb-alert>

                <button class="btn btn-primary" (click)="return();">
                  {{ 'pages.updates.integrations.returnToInitial' | translate }}
                </button>
            </div>
          </div>
            
        </div>
    </div>

  </div>
</div>

